import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import CloseIcon from '@mui/icons-material/Close';

import { getNameFromId } from '../../../../utils/directusFunctions';
import TextAreaField from '../../../formElements/TextAreaField';
import LoadingSpinner from '../../../ui/LoadingSpinner';

import app from '../../../../app.module.css';
import dropdownClasses from '../../recruitmentStyles/rowDropDown.module.css';

const RejectionDetails = ({ row, onClose }) => {
    // LOCAL STATE
    const [reasonNames, setReasonNames] = useState([]);

    // STORE STATE
    const poolAcceptedRejectionReasonsDetails = useSelector(
        (state) => state.entities.directusService.poolAcceptedRejectionReasonsDetails
    );
    const poolRequestedRejectionReasonsDetails = useSelector(
        (state) => state.entities.directusService.poolRequestedRejectionReasonsDetails
    );

    // EVENT HANDLERS
    useEffect(() => {
        if (row?.reasons === '') return;
        let reasonNames = row?.reasons.map((el) =>
            getNameFromId(poolAcceptedRejectionReasonsDetails, el)
        );
        if (reasonNames[0] === '')
            reasonNames = row?.reasons.map((el) =>
                getNameFromId(poolRequestedRejectionReasonsDetails, el)
            );
        setReasonNames(reasonNames);
    }, []);

    return !row ? (
        <LoadingSpinner content="No rejection information found" />
    ) : (
        <div className={dropdownClasses.rowDropdown}>
            <div className={app.sectionHeading} data-testid="form_start">
                {row.ptCode} ({row.ptName})
            </div>
            <h5>Rejection Reasons</h5>
            <TextAreaField id={'reasons'} disabled={true} value={reasonNames.join(', ')} rows={3} />
            <h5>Rejection Feedback</h5>
            <TextAreaField id={'notes'} disabled={true} value={row?.notes || ''} rows={4} />
            <div className={dropdownClasses.exit} onClick={onClose}>
                Close details
                <CloseIcon />
            </div>
        </div>
    );
};

export default RejectionDetails;

RejectionDetails.propTypes = {
    row: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};
